import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type UseRemoveStaffFailureAlertRecipientMutationVariables = {
  email: string;
};

export const useRemoveStaffFailureAlertRecipientMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ email }: UseRemoveStaffFailureAlertRecipientMutationVariables) => {
      const { data } = await authApi.delete<{ staffFailureAlertRecipients: string[] }>(
        "/staff/staff-failure-alert-recipients",
        { data: { email } }
      );
      return data.staffFailureAlertRecipients;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["staff-failure-alert-recipients"],
      });
    },
  });
};
